//#region Import
import React from 'react';
/* React Router */
import { NavLink, withRouter } from 'react-router-dom';

/* Routes */
import { domain, isTenant, pathPrefixS, pathPrefixC, S, S_TENANT, AppLink } from '../../routes/routes';

/* Object Json */
import { safeDeepGet, safeDeepGetWithType } from 'iotera-base/json';

import { isFunction } from 'iotera-base/object';
import { CustomNavStyle } from '../../lib/preferences/nav-style';

/* React Strap */
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';

/* Logo */
import Logo from '../../lib/components/iconColor/logo.png'
import LogoOnly from '../../lib/components/iconColor/logo-only.png'

import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Divider from '@material-ui/core/Divider';

/* Icon */
import DashboardIcon from '@material-ui/icons/Dashboard';
import UsersIcon from '@material-ui/icons/People';
import RoleIcon from '@material-ui/icons/AssignmentInd';
import DevicesIcon from '@material-ui/icons/DeviceHub';
import TagsIcon from '@material-ui/icons/LocalOffer';
import RuleIcon from '@material-ui/icons/Assignment';
import TaskIcon from '@material-ui/icons/AssignmentLate';
import { MdCropFree as IconFullScreen, MdWidgets as IconWidget, MdPowerSettingsNew as IconLogout } from 'react-icons/md';

import Person from '@material-ui/icons/Person';
import MenuIcon from '@material-ui/icons/ViewList';
import MiniIcon from '@material-ui/icons/MoreVert';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import KeyIcon from '@material-ui/icons/VpnKey';
import NoteIcon from '@material-ui/icons/Note';

/* Tooltip */
import Tooltip from '@material-ui/core/Tooltip';
import Zoom from '@material-ui/core/Zoom';

/* Style */
import './style.scss';

/* Screenfull */
import screenfull from 'screenfull';

import { NavigationDrawerWithTooltip } from '../../lib/components/navigation';
import IoteraClass from '../../lib/components/react/react-class';
//#endregion

const NavHead = (props) => {
  if (props.open) {
    return (
      <header >
        <img src={Logo} alt="Logo" width='auto' height={36} />
      </header>
    );
  } else {
    return (
      <header >
        <img src={LogoOnly} alt="Logo" width='auto' height={36} />
      </header>
    );
  }

}

class MiniDrawer extends IoteraClass {
  constructor(props) {
    super(props);
    // let open = this.props.open;

    const _isTenant = isTenant(props);
    this.state = {
      _isTenant
      // open
    };
    this.handleClick = this.handleClick.bind(this);

    this.handleLogout = this.handleLogout.bind(this);
    this.handleApi = this.handleApi.bind(this);
  }

  handleClick = (location) => {
    if (window.innerWidth <= 5000) {
      if (isFunction(this.props.hideNav)) {
        this.props.hideNav();
      }
    }


    if (location !== S) {
      this.props.history.push(location)
    }

  }

  handleDrawerOpen = () => {
    this.setState({ open: true });
    if (isFunction(this.props.toggleNav)) {
      this.props.toggleNav();
    }
  };

  handleDrawerClose = () => {
    this.setState({ open: false });
    if (isFunction(this.props.toggleNav)) {
      this.props.toggleNav();
    }

  };

  handleLogout = (e) => {
    const logout = safeDeepGet(this, ['props', 'logout']);
    if (isFunction(logout)) {
      logout();
    }
  }

  handleApi = (e) => {

  }

  render() {
    const { classes, theme } = this.props;

    const _domain = domain(this.props);

    const _isTenant = safeDeepGetWithType(this, ['state', "_isTenant"], false);
    const pathApi = _isTenant ? '_dashboard_list_' : '_api_'
    const _prefixS = pathPrefixS(_domain, _isTenant);

    const _prefixSC = pathPrefixC(_domain, _isTenant);

    let to = S;
    if (_isTenant) {
      to = S_TENANT;
    } else {
      to = _prefixSC;
    }
    let titleHome;
    if (_isTenant) {
      titleHome = "List Aplikasi"
    } else {
      titleHome = "Halaman Utama"
    }

    const navMap = safeDeepGetWithType(this, ['props', 'map'], {});
    let navs = '';
    let navsSys = '';
    let key = 1;
    let keySys = 1;

    let location = safeDeepGet(this, ['props', 'location', 'pathname'], '');
    const title = safeDeepGetWithType(this, ['props', 'titleHeader'], '')

    let userNavs = []
    let userNavsSys = []

    if (_isTenant) {
      let tenantNavs = [
        {
          label: "Dashboard",
          icon: DashboardIcon,
          path: '_dashboard_list_',
          key: 1
        },
        {
          label: "Role",
          icon: RoleIcon,
          path: '_role_list_',
          key: 2
        },
        {
          label: "Pengguna",
          icon: UsersIcon,
          path: '_user_list_',
          key: 3
        },
        {
          label: "Perangkat",
          icon: DevicesIcon,
          path: '_device_list_',
          key: 4
        },
        {
          label: "Penanda",
          icon: TagsIcon,
          path: '_tag_list_',
          key: 5
        },
        {
          label: "Rule",
          icon: RuleIcon,
          path: '_rule_list_',
          key: 6
        },
        {
          label: "Tugas",
          icon: TaskIcon,
          path: '_task_list_',
          key: 7
        },
        {
          label: "Credentials",
          icon: KeyIcon,
          path: '@credentials',
          key: 8
        },
        {
          label: "About",
          icon: NoteIcon,
          path: '@about',
          key: 9
        }
      ];

      // Dashboard Management
      navs =
        <NavigationDrawerWithTooltip
          prefix={_prefixS} handleClick={this.handleClick} location={location} classes={classes} open={this.props.open} navList={tenantNavs}
        />
    } else {
      let userManageFlag = false;
      let deviceListFlag = false;
      let taskListFlag = false;

      // TODO check if nav have _task_list_
      for (let id in navMap) {
        const nav = navMap[id];
        const path = safeDeepGetWithType(nav, ['path'], '');
        if (path === '_dashboard_manage_') {
          userNavs.push(
            { label: 'Dasboard', icon: DashboardIcon, path: '_dashboard_list_', key }
          )
          ++key;
        } else if (path === '_role_manage_') {
          userNavs.push(
            { label: 'Role', icon: RoleIcon, path: '_role_list_', key }
          )
          ++key;
          if (!userManageFlag) {
            userNavs.push(
              { label: 'Pengguna', icon: UsersIcon, path: '_user_list_', key }
            )
            ++key;
            userManageFlag = true;
          }
        } else if (path === '_user_manage_') {
          if (!userManageFlag) {
            userNavs.push(
              { label: 'Pengguna', icon: UsersIcon, path: '_user_list_', key }
            )
            ++key;
            userManageFlag = true;
          }

        } else if (path === '_device_manage_') {

          if (!deviceListFlag) {
            userNavs.push(
              { label: 'Perangkat', icon: DevicesIcon, path: '_device_list_', key }
            )
            ++key;
            deviceListFlag = true;
          }
        } else if (path === '_device_list_') {
          if (!deviceListFlag) {
            userNavs.push(
              { label: 'Perangkat', icon: DevicesIcon, path: '_device_list_', key }
            )
            ++key;
            deviceListFlag = true;
          }
        } else if (path === '_task_manage_') {
          if (!taskListFlag) {
            taskListFlag = true;
          }
        } else if (path === '_task_list_') {
          if (!taskListFlag) {

            userNavsSys.push(
              { label: "Tugas", icon: TaskIcon, path: "_task_list_", key: keySys }
            )
            keySys++

            taskListFlag = true;
          }
        }
      }

      for (let id in navMap) {
        const nav = navMap[id];
        const path = safeDeepGetWithType(nav, ['path'], '');
        if (path.includes('_')) {
          continue;
        }
        const label = safeDeepGetWithType(nav, ['label'], '');
        const children = safeDeepGetWithType(nav, ['children'], []);

        userNavs.push(
          { label, icon: DashboardIcon, path, children, key }
        )
        ++key;
      }

      navs =
        <NavigationDrawerWithTooltip
          prefix={_prefixS} handleClick={this.handleClick} location={location} classes={classes} open={this.props.open} navList={userNavs} navSysList={userNavsSys} isTenant={false}
        />

      navsSys =
        <NavigationDrawerWithTooltip
          prefix={_prefixS} handleClick={this.handleClick} location={location} classes={classes} open={this.props.open} navList={userNavsSys} navSysList={userNavsSys} isTenant={false}
        />
      ++key;
    }
    let drawerVariant = window.innerWidth <= 5000 ? null : 'permanent'
    return (
      <div className={classes.root}>
        <CssBaseline />
        <AppBar
          position="static"
          className={classNames(classes.appBar, {
            [classes.appBarShift]: this.props.open,
          })}
        >
          <Toolbar disableGutters={!this.props.open}>
            {window.innerWidth <= 5000 ?
              this.props.open ?
                <Tooltip TransitionComponent={Zoom} title="Mini Menu" enterDelay={500}>
                  <IconButton
                    color="inherit"
                    onClick={this.handleDrawerClose}
                    className={classNames(classes.menuButton, {
                      [classes.hide]: !this.props.open,
                    })}>
                    {theme.direction === 'rtl' ? <MiniIcon /> : <MiniIcon />}
                  </IconButton>
                </Tooltip>
                :
                <Tooltip TransitionComponent={Zoom} title="Menu" enterDelay={500}>
                  <IconButton
                    color="inherit"
                    aria-label="Open drawer"
                    onClick={this.handleDrawerOpen}
                    className={classNames(classes.menuButton, {
                      [classes.hide]: this.props.open,
                    })}
                  >
                    <MenuIcon />
                  </IconButton>
                </Tooltip>
              :
              <div style={{ marginRight: 12 }} />
            }

            {/* TODO not slide */}
            <Typography variant="h5" color="inherit" style={{ flexGrow: 1, textTransform: 'capitalize' }}>
              {title}
            </Typography>

            <div >
              <Tooltip TransitionComponent={Zoom} title="Full Screen" enterDelay={500}>
                {screenfull.enabled ?
                  <IconButton color="inherit" aria-label="Menu" onClick={event => screenfull.toggle()}  >
                    <IconFullScreen size="24" />
                  </IconButton>
                  :
                  <IconButton color="inherit" aria-label="Menu"  >
                    <IconFullScreen size="24" />
                  </IconButton>
                }

              </Tooltip>
            </div>

            <div>
              <Tooltip TransitionComponent={Zoom} title="Akses" enterDelay={500}>
                <UncontrolledDropdown>
                  <DropdownToggle tag="div">
                    <IconButton color="inherit" aria-label="Menu" >
                      <Person size="24" />
                    </IconButton>
                  </DropdownToggle>
                  <DropdownMenu right style={{ minWidth: '12rem' }}>
                    {this.props.hideApi ?
                      <DropdownItem onClick={this.handleLogout} ><IconLogout size="16" />
                                                &emsp;Logout</DropdownItem>
                      :
                      <React.Fragment>
                        {/* <AppLink {...this.props} to={pathApi}  >
                          <DropdownItem
                            style={{ marginLeft: 7 }}
                          >
                            <IconWidget size="16" />
                                                        &emsp;API
                                                    </DropdownItem>
                        </AppLink> */}
                        <DropdownItem onClick={this.handleLogout} style={{ marginLeft: 7 }} ><IconLogout size="16" />
                                                    &emsp;Logout</DropdownItem>
                      </React.Fragment>
                    }
                  </DropdownMenu>
                </UncontrolledDropdown>
              </Tooltip>
            </div>
          </Toolbar>
        </AppBar >
        <SwipeableDrawer
          variant={drawerVariant}
          anchor="left"
          onClose={this.handleDrawerClose}
          onOpen={this.handleDrawerOpen}
          className={classNames(classes.drawer, {
            [classes.drawerOpen]: this.props.open,
            [classes.drawerClose]: !this.props.open,
          })}
          classes={{
            paper: classNames({
              [classes.drawerOpen]: this.props.open,
              [classes.drawerClose]: !this.props.open,
            }),
          }}
          swipeAreaWidth={0}
          open={this.props.open}
        >
          <Tooltip TransitionComponent={Zoom} title={titleHome} placement='bottom-start' enterDelay={500} >
            <NavLink activeClassName='active' to={to}>
              <div className={classes.toolbar}>
                <NavHead open={this.props.open} />
              </div>
            </NavLink>
          </Tooltip>
          <Divider />
          <div style={{
            overflowX: 'auto', overflowY: 'auto',
            WebkitOverflowScrolling: 'touch',
            msOverflowStyle: '-ms-autohiding-scrollbar'
          }}>
            <List className="list-unstyled">
              {this.props.open && <ListItem style={{ padding: 0 }}><div className={classes.navListTitle}>Aplikasi</div></ListItem>}
              {userNavsSys.length > 0 &&
                <React.Fragment>
                  {navsSys}
                  <Divider style={{ margin: '5px 0px 10px 40px' }} />
                </React.Fragment>
              }
              {navs}
            </List>
          </div>
        </SwipeableDrawer>
      </div >
    );
  }
}

MiniDrawer.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(CustomNavStyle, { withTheme: true })(withRouter(MiniDrawer));